import { useSyncExternalStore } from 'react';

import { createTicker } from './createTicker';

const minute = createTicker(60_000);

export const useMinuteTick = (): number => useSyncExternalStore(minute.subscribe, minute.getSnapshot, minute.getSnapshot);
